import styled from '@emotion/styled'
import { calcRem, metrics } from '../../../__styling'

export const StyledWardenParagraph = styled('p')(({ theme }) => [
    {
        fontFamily: theme.fonts.sansSerif,
        fontSize: calcRem(metrics.thenightly.baseFontSize),
        fontWeight: 400,
        lineHeight: calcRem(24),
        color: theme.colors.text.tertiary,

        // Handle formatting on all clickable links below:
        a: {
            textDecorationLine: 'underline',
        },
    },
    // PerthNow styling
    theme.kind === 'perthnow' && {
        color: theme.colors.text.weak,
        fontSize: calcRem(metrics.perthnow.baseFontSize),
    },
])
StyledWardenParagraph.displayName = 'StyledWardenParagraph'
